export * from '@primeuix/themes/lara/dataview';
export { default } from '@primeuix/themes/lara/dataview';
